import instance from "../services";

const paymentAPI = {
    /**
     * PC 결제 요청
     * @param {Object} params
     * @returns {Promise<AxiosResponse<any>>}
     */
    RequestPayment(params) {
        return instance.post('/api/pay/request', params);
    },

    /**
     * 모바일 결제 요청
     * @param {Object} params
     * @returns {Promise<AxiosResponse<any>>}
     */
    RequestMobilePayment(params) {
        return instance.post('/api/pay/request', params);
    }
};

export default paymentAPI;